import { Timer } from "lucide-react";
import { useEffect, useState } from "react";
import { Card, Section } from "../Layout";
import { useI18n } from "../i18n";

const WEDDING_DATE = new Date("2026-08-29T00:00:00+02:00");

function getTimeLeft() {
  const difference = Math.max(WEDDING_DATE.getTime() - Date.now(), 0);
  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((difference / (1000 * 60)) % 60);
  const seconds = Math.floor((difference / 1000) % 60);

  return {
    days,
    hours,
    minutes,
    seconds,
    isComplete: difference === 0,
  };
}

function TimeCard({ label, value }) {
  return (
    <div className="rounded-3xl border border-theme-border bg-theme-surface px-4 py-5 text-center sm:px-6 sm:py-6">
      <p className="font-serif text-4xl leading-none text-theme-text sm:text-5xl">
        {String(value).padStart(2, "0")}
      </p>
      <p className="mt-3 text-xs uppercase tracking-[0.26em] text-theme-text-subtle">{label}</p>
    </div>
  );
}

export default function Countdown() {
  const { t } = useI18n();
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft());

  useEffect(() => {
    const timerId = window.setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);

    return () => {
      window.clearInterval(timerId);
    };
  }, []);

  const timeCards = [
    { key: "days", label: t("countdown.days"), value: timeLeft.days },
    { key: "hours", label: t("countdown.hours"), value: timeLeft.hours },
    { key: "minutes", label: t("countdown.minutes"), value: timeLeft.minutes },
    { key: "seconds", label: t("countdown.seconds"), value: timeLeft.seconds },
  ];

  return (
    <Section
      id="countdown"
      eyebrow={t("countdown.eyebrow")}
      title={t("countdown.title")}
      icon={Timer}
    >
      <Card className="p-6 sm:p-8">
        <p className="text-center text-sm leading-relaxed text-theme-text-muted">{t("countdown.subtitle")}</p>

        {!timeLeft.isComplete ? (
          <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4">
            {timeCards.map((item) => (
              <TimeCard key={item.key} label={item.label} value={item.value} />
            ))}
          </div>
        ) : (
          <div className="mt-6 rounded-3xl border border-theme-border bg-theme-surface px-6 py-7 text-center">
            <p className="font-serif text-3xl text-theme-text">{t("countdown.complete_title")}</p>
            <p className="mt-2 text-sm text-theme-text-muted">{t("countdown.complete_text")}</p>
          </div>
        )}

        <p className="mt-6 text-center text-xs uppercase tracking-[0.25em] text-theme-text-faint">
          {t("countdown.wedding_day")}
        </p>
      </Card>
    </Section>
  );
}
